import { render, staticRenderFns } from "./SuccessHostPass.vue?vue&type=template&id=06a803ce"
import script from "./SuccessHostPass.vue?vue&type=script&lang=js"
export * from "./SuccessHostPass.vue?vue&type=script&lang=js"
import style0 from "./SuccessHostPass.vue?vue&type=style&index=0&id=06a803ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports